import React from 'react';
import { omit } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Grid, Row, Col, Icon, Input, InputGroup } from 'rsuite';

const InventorySearch = ({
  query,
  queryOptions,
  placeholder,
  onChange,
  onSubmit,
  isFetching
}) => {
  const handleOnChange = q => {
    onChange({ q });
  };
  return (
    <Grid fluid style={{ padding: 0, marginLeft: 0 }}>
      <Row gutter={8}>
        <Col xs={6}>
          <InputGroup>
            <Input
              value={query}
              onChange={handleOnChange}
              style={{ paddingLeft: 10 }}
              placeholder={placeholder}
              disabled={isFetching}
              onKeyPress={({ key }) => {
                if (key === 'Enter' && query !== '') onSubmit(queryOptions);
              }}
            />
            <InputGroup.Button
              style={{ borderBottom: 'none' }}
              disabled={!query || isFetching}
              onClick={() => {
                if (query !== '') onSubmit(queryOptions);
              }}
            >
              <Icon icon="search" />
            </InputGroup.Button>
            {query && (
              <InputGroup.Button
                style={{ borderBottom: 'none' }}
                disabled={isFetching}
                onClick={() => {
                  handleOnChange('');
                  onSubmit(omit('q', queryOptions));
                }}
              >
                <Icon icon="refresh" />
              </InputGroup.Button>
            )}
          </InputGroup>
        </Col>
        {/* <Col xs={5}>
        <DateRangePicker
          value={query.dateRange}
          placeholder="Select date range"
          name="dateRange"
          defaultValue={[]}
        />
      </Col> */}
      </Row>
    </Grid>
  );
};

InventorySearch.propTypes = {
  placeholder: PropTypes.string.isRequired,
  query: PropTypes.string.isRequired,
  queryOptions: PropTypes.shape({}),
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired
};

InventorySearch.defaultProps = {
  queryOptions: {}
};

export default InventorySearch;
